import { Component, createRef } from "react";
import { IBaseComponentProps, NSBox, NSInfoProps, NSLabel, NSRepeater, NSRow } from "namirasoft-site-react";
import LookbackPeriodLine from "./LookbackPeriodLine";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { BillWatchProps } from "../BillWatchProps";
import { LookbackPeriodRow } from "namirasoft-bill-watch";

export interface LookbackPeriodsProps extends IBaseComponentProps, NSARouterMakerResult, BillWatchProps 
{
	info?: NSInfoProps;
}

export default class LookbackPeriods extends Component<LookbackPeriodsProps>
{
	NSRepeater_LookbackPeriods = createRef<NSRepeater<LookbackPeriodLine, LookbackPeriodRow>>();

	override render()
	{
		return (
			<NSRow
				style={{
					width: NSBox.width.triple
				}}
			>
				<NSLabel
					title="This configuration runs all detection rules across each selected timeframe."
					description="Lookback periods define how far back in time we analyze your cost data. You can choose one or multiple timeframes such as the last 7 days or the last 30 days and we will run all anomaly detection rules separately on each selected period."
					classList={["nsbw-label"]}
				>
					{
						this.props.info &&
						<a href={this.props.info.link} target='_blank' rel="noreferrer" style={{ marginLeft: "4px" }}>Read More</a>
					}
				</NSLabel>
				<NSRepeater<LookbackPeriodLine, LookbackPeriodRow>
					ref={this.NSRepeater_LookbackPeriods}
					title="Lookback Periods"
					required
					min={1}
					createItem={(gIndex: number, lIndex: number, ref: React.RefObject<LookbackPeriodLine>, onChange: () => void, onDelete: undefined | ((index: number) => void)) =>
					{
						return <LookbackPeriodLine
							ref={ref}
							{...this.props}
							key={`${this.props.name}_LookbackPeriods_NSRepeater_LookbackPeriodsLine_key_${gIndex}`}
							index={lIndex}
							deletable={true}
							onChanged={() =>
							{
								onChange();
							}}
							onDelete={() =>
							{
								onDelete?.(lIndex);
							}}
						/>;
					}}
					isEmpty={function (_, value: LookbackPeriodRow | null): boolean
					{
						return !LookbackPeriodLine.IS_DIRTY(value);
					}}
					getValue={function (item: LookbackPeriodLine, checkError: boolean): LookbackPeriodRow
					{
						return item.getValue(checkError);
					}}
					setValue={function (item: LookbackPeriodLine, _: number, value: LookbackPeriodRow | null): void
					{
						if (value)
							item.setValue(value);
					}}
					style={{ width: "100%", maxWidth: NSBox.width.triple }}
				/>
			</NSRow>
		);
	}
}